export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 100 CARDS',
    cards: [
      {n:'1', name:'The Skywalker Saga: Luke', artist:'Carlos Cabaleiro'},
      {n:'2', name:'The Light of Padmé Amidala', artist:'Marcia Dye'},
      {n:'3', name:'Aurra Sing on Tatooine', artist:'Darrin Pepe'},
      {n:'4', name:'Student becomes Teacher', artist:'Randy Martinez'},
      {n:'5', name:'The Battle of Hoth', artist:'Ingrid Hardy'},
      {n:'6', name:'United behind General Grievous', artist:'Ben AbuSaada'},
      {n:'7', name:'Rey The Scavenger', artist:'Andrew Fry'},
      {n:'8', name:'Mos Eisley After Dark', artist:'Eric Lehtonen'},
      {n:'9', name:'Triple Threat', artist:'Kyle Babbit'},
      {n:'10', name:'A Family Affair', artist:'Mike James Horgan'},
      {n:'11', name:'Hero of the Resistance', artist:'Brad Hudson'},
      {n:'12', name:'Between Light and Darkness', artist:'Alex Iniguez'},
      {n:'13', name:'Duel on Mustafar', artist:'Evan Shoman'},
      {n:'14', name:'Jar Jar Binks and Otoh Gunga', artist:'Matt Maldonado'},
      {n:'15', name:'The Plan to Rescue Han Solo', artist:'Jim Mehsling'},
      {n:'16', name:"Darth Vader's Wrath", artist:'JP Perez'},
      {n:'17', name:'Blending In', artist:'Solly Mohamed'},
      {n:'18', name:'The Skywalker Saga: Leia', artist:'Carlos Cabaleiro'},
      {n:'19', name:'A Lily Among Thorns', artist:'Stephanie Rosales'},
      {n:'20', name:'Rising Light in the Darkness', artist:'Adam Schickling'},
      {n:'21', name:'Captain Rex Surveys the Battlefield', artist:'Anil Sharma'},
      {n:'22', name:'Battle of Scarif', artist:'Jennifer Allyn'},
      {n:'23', name:'Poe Dameron, Leader of Black Squadron', artist:'Paul Andrews'},
      {n:'24', name:'Commander Poe Dameron', artist:'Randy Martinez'},
      {n:'25', name:"Jyn Erso's Purpose", artist:'Louise Draper'},
      {n:'26', name:'Operation: Fracture', artist:'Brian Kong'},
      {n:'27', name:'Darth Maul Reborn', artist:'Mark Mangum'},
      {n:'28', name:'The Final Duel', artist:'Chris Meeks'},
      {n:'29', name:'Tatooine Troopers', artist:'Marsha Parkins'},
      {n:'30', name:'Boba Fett: Bounty Hunter', artist:'JH Smith'},
      {n:'31', name:'Teachings on Dagobah', artist:'Tim Smith'},
      {n:'32', name:'Rebel Jyn Erso', artist:'Andrew Fry'},
      {n:'33', name:'The Two Tubes Brothers of Jedha', artist:'Doug Wheatley'},
      {n:'34', name:'Light Rises to Meet the Dark', artist:'Bob Stevlic'},
      {n:'35', name:'The Bounty Hunter', artist:'Doug Cowan'},
      {n:'36', name:'Dark Warrior, Kylo Ren', artist:'Trent Westbrook'},
      {n:'37', name:'Emperor Palpatine', artist:'Caleb King'},
      {n:'38', name:'The Resistance Pilots', artist:'Joe Corroney'},
      {n:'39', name:'The Rebel Commander', artist:'Dan Bergren'},
      {n:'40', name:'Droids of the Resistance', artist:'Chris Clark'},
      {n:'41', name:'Leading the Imperial Army', artist:'Bryan Snuffer'},
      {n:'42', name:'The Sand People', artist:'Kris Penix'},
      {n:'43', name:"Thrawn's Private Quarters", artist:'Rich Molinelli'},
      {n:'44', name:'By the Lake', artist:'Angelina Benedetti'},
      {n:'45', name:'The Jedi Master', artist:'Kevin Cleveland'},
      {n:'46', name:"Luke Skywalker's Journey", artist:'Gerry Garcia'},
      {n:'47', name:'In Service of Jabba the Hutt', artist:'Frank Kadar'},
      {n:'48', name:'Poe Dameron and BB-8', artist:'Jamie Richards'},
      {n:'49', name:'Stardust on Scarif', artist:'Todd Aaron Smith'},
      {n:'50', name:'Duel of the Fates', artist:'Trent Westbrook'},
      {n:'51', name:"The First Order's Enforcer", artist:'Joe Coronney'},
      {n:'52', name:'Rey Dines Alone', artist:'Erik Maell'},
      {n:'53', name:'The Podrace'},
      {n:'54', name:'Flight of Fett'},
      {n:'55', name:'Fury comes to Bespin'},
      {n:'56', name:'Aftermath on the Tantive IV'},
      {n:'57', name:'The Lord of the Sith'},
      {n:'58', name:"The Farmboy's Future"},
      {n:'59', name:'The Princess prepared'},
      {n:'60', name:'Captain Han Solo'},
      {n:'61', name:'Crushing the Empire'},
      {n:'62', name:'Jedi in Hiding'},
      {n:'63', name:"The Droid's Journey"},
      {n:'64', name:'A Jedi alone'},
      {n:'65', name:'Galaxy of Evil'},
      {n:'66', name:'Tailed by TIEs'},
      {n:'67', name:'The Empire and beyond'},
      {n:'68', name:'Heroes towards Endor'},
      {n:'69', name:'Above the Sarlacc'},
      {n:'70', name:'The Golden Deity'},
      {n:'71', name:'The Tatooine Gangster'},
      {n:'72', name:'The Max Rebo Band'},
      {n:'73', name:'Fighting the Rancor'},
      {n:'74', name:'The Final Duel'},
      {n:'75', name:'Finding a new friend'},
      {n:'76', name:'The Failed Execution'},
      {n:'77', name:'Revenge of the Sith'},
      {n:'78', name:'Battle in the Arena'},
      {n:'79', name:'The Birth of Darth Vader'},
      {n:'80', name:'Fearsome Fett'},
      {n:'81', name:'The End of the Jedi'},
      {n:'82', name:'Speeder Bike Battle'},
      {n:'83', name:"Boba Fett's Bounty"},
      {n:'84', name:'Jedi Master'},
      {n:'85', name:"Wicket's Relic"},
      {n:'86', name:'Rogue Leader in Flight'},
      {n:'87', name:'The Frozen Plains of Hoth'},
      {n:'88', name:'The Mandalorian Hunter'},
      {n:'89', name:'Dueling Darth Vader'},
      {n:'90', name:'Captain and Co-pilot'},
      {n:'91', name:"The Millennium Falcon's Escape"},
      {n:'92', name:'General Calrissian'},
      {n:'93', name:'The Armored Imperial Fortress'},
      {n:'94', name:'Captain of the 501st'},
      {n:"95", name:"Wedge's Lead"},
      {n:'96', name:'Departing Bespin'},
      {n:'97', name:'The Palace and the Band'},
      {n:'98', name:'General Grievous'},
      {n:"99", name:"The Emperor's Wrath"},
      {n:'100', name:"Darth Vader's Element"},
    ]
  },
  {
    id: 'rogue-one-propaganda', parallels: [{id:'plate-black',name:'Printing Plate Black',print_run:1,color:'#808080'},{id:'plate-cyan',name:'Printing Plate Cyan',print_run:1,color:'#00e5ff'},{id:'plate-magenta',name:'Printing Plate Magenta',print_run:1,color:'#e91e63'},{id:'plate-yellow',name:'Printing Plate Yellow',print_run:1,color:'#ffee58'}], type: 'insert', title: 'ROGUE ONE PROPAGANDA — 9 CARDS',
    cards: [
      {n:'RP-1', name:'Be Vigilant', artist:'Russell Walks'},
      {n:'RP-2', name:'We Have Them Now', artist:'Russell Walks'},
      {n:'RP-3', name:'Never Surrender', artist:'Russell Walks'},
      {n:'RP-4', name:'A Future Built On Hope', artist:'Russell Walks'},
      {n:'RP-5', name:'Your Destiny Awaits You', artist:'Russell Walks'},
      {n:'RP-6', name:'Strike', artist:'Russell Walks'},
      {n:'RP-7', name:'Armed And Operational', artist:'Russell Walks'},
      {n:'RP-8', name:'Heroes', artist:'Russell Walks'},
      {n:'RP-9', name:'For The Glory Of The Empire', artist:'Russell Walks'},
    ]
  },
  {
    id: 'new-trilogy-propaganda', parallels: [{id:'plate-black',name:'Printing Plate Black',print_run:1,color:'#808080'},{id:'plate-cyan',name:'Printing Plate Cyan',print_run:1,color:'#00e5ff'},{id:'plate-magenta',name:'Printing Plate Magenta',print_run:1,color:'#e91e63'},{id:'plate-yellow',name:'Printing Plate Yellow',print_run:1,color:'#ffee58'}], type: 'insert', title: 'NEW TRILOGY PROPAGANDA — 6 CARDS',
    cards: [
      {n:'TP-1', name:"You're Our Only Hope", artist:'Russell Walks'},
      {n:'TP-2', name:'Victory', artist:'Russell Walks'},
      {n:'TP-3', name:'We Need You', artist:'Russell Walks'},
      {n:'TP-4', name:'Irresistable Power', artist:'Russell Walks'},
      {n:'TP-5', name:'Crush The Resistance', artist:'Russell Walks'},
      {n:'TP-6', name:'Resist', artist:'Russell Walks'},
    ]
  },
  {
    id: 'journey-ahsoka', type: 'insert', title: 'JOURNEY OF AHSOKA — 10 CARDS',
    cards: [
      {n:'JA-1', name:'Journey of Ahsoka 1 of 10', artist:'Dave Filoni'},
      {n:'JA-2', name:'Journey of Ahsoka 2 of 10', artist:'Dave Filoni'},
      {n:'JA-3', name:'Journey of Ahsoka 3 of 10', artist:'Dave Filoni'},
      {n:'JA-4', name:'Journey of Ahsoka 4 of 10', artist:'Dave Filoni'},
      {n:'JA-5', name:'Journey of Ahsoka 5 of 10', artist:'Dave Filoni'},
      {n:'JA-6', name:'Journey of Ahsoka 6 of 10', artist:'Dave Filoni'},
      {n:'JA-7', name:'Journey of Ahsoka 7 of 10', artist:'Dave Filoni'},
      {n:'JA-8', name:'Journey of Ahsoka 8 of 10', artist:'Dave Filoni'},
      {n:'JA-9', name:'Journey of Ahsoka 9 of 10', artist:'Dave Filoni'},
      {n:'JA-10', name:'Journey of Ahsoka 10 of 10', artist:'Dave Filoni'},
    ]
  },
  {
    id: 'legends', parallels: [{id:'purple',name:'Purple',print_run:99,color:'#b060ff'},{id:'orange',name:'Orange',print_run:25,color:'#ff9100'},{id:'plate-black',name:'Printing Plate Black',print_run:1,color:'#808080'},{id:'plate-cyan',name:'Printing Plate Cyan',print_run:1,color:'#00e5ff'},{id:'plate-magenta',name:'Printing Plate Magenta',print_run:1,color:'#e91e63'},{id:'plate-yellow',name:'Printing Plate Yellow',print_run:1,color:'#ffee58'},{id:'red',name:'Red',print_run:1,color:'#ff1744'}], type: 'insert', title: 'LEGENDS — 5 CARDS',
    cards: [
      {n:'C-1', name:'Luke Skywalker', artist:'Mick & Matt Glebe'},
      {n:'C-2', name:'Leia Organa', artist:'Mick & Matt Glebe'},
      {n:'C-3', name:'Kylo Ren', artist:'Mick & Matt Glebe'},
      {n:'C-4', name:'Rey', artist:'Mick & Matt Glebe'},
      {n:'C-5', name:'Finn', artist:'Mick & Matt Glebe'},
    ]
  },
  {
    id: 'galaxy-puzzle', parallels: [], type: 'insert', title: 'GALAXY PUZZLE — 6 CARDS',
    cards: [
      {n:'GP-1', name:'Poe Dameron & Leia Organa', artist:'Joe Corroney'},
      {n:'GP-2', name:'Luke Skywalker', artist:'Joe Corroney'},
      {n:'GP-3', name:'Finn & Rose', artist:'Joe Corroney'},
      {n:'GP-4', name:'Rey & Chewbacca', artist:'Joe Corroney'},
      {n:'GP-5', name:'Supreme Leader Snoke', artist:'Joe Corroney'},
      {n:'GP-6', name:'Kylo Ren & General Hux', artist:'Joe Corroney'},
    ]
  },
  {
    id: 'wanted-posters', parallels: [], type: 'insert', title: 'WANTED POSTERS — 6 CARDS',
    cards: [
      {n:'P-1', name:'Ezra Bridger'},
      {n:'P-2', name:'Kanan Jarrus'},
      {n:'P-3', name:'Hera Syndulla'},
      {n:'P-4', name:'Sabine Wren'},
      {n:'P-5', name:'Zeb Orrelios'},
      {n:'P-6', name:'Chopper'},
    ]
  },
  {
    id: 'art-patches', parallels: [{id:'blue',name:'Blue',print_run:199,color:'#2979ff'},{id:'green',name:'Green',print_run:150,color:'#00e676'},{id:'purple',name:'Purple',print_run:99,color:'#b060ff'},{id:'orange',name:'Orange',print_run:25,color:'#ff9100'},{id:'red',name:'Red',print_run:1,color:'#ff1744'}], type: 'insert', title: 'ART PATCHES — 17 CARDS',
    cards: [
      {n:'M-2B', name:'2-1B'},
      {n:'M-AT', name:'AT-ST'},
      {n:'M-C', name:'Chewbacca'},
      {n:'M-D', name:'Droids'},
      {n:'M-DV', name:'Darth Vader'},
      {n:'M-HL', name:'Han and Leia'},
      {n:'M-JW', name:'Jawas'},
      {n:'M-LL', name:'Luke and Leia'},
      {n:'M-LS', name:'Luke Skywalker'},
      {n:'M-OK', name:'Obi-Wan Kenobi'},
      {n:'M-PL', name:'Princess Leia'},
      {n:'M-RM', name:'Rancor Monster'},
      {n:'M-SC', name:'Salacious B. Crumb'},
      {n:'M-TR', name:'Tusken Raider'},
      {n:'M-WT', name:'Wilhuff Tarkin'},
      {n:'M-WW', name:'Wicket W. Warrick'},
      {n:'M-XW', name:'X-Wings'},
    ]
  },
  {
    id: 'auto-single', type: 'auto', title: 'AUTOGRAPHS — 54 CARDS',
    cards: [
      {n:'A-HF', name:'Harrison Ford', artist:'Han Solo'},
      {n:'A-CF', name:'Carrie Fisher', artist:'Princess Leia Organa'},
      {n:'A-PM', name:'Peter Mayhew', artist:'Chewbacca'},
      {n:'A-AD2', name:'Anthony Daniels', artist:'C-3PO'},
      {n:'A-KB', name:'Kenny Baker', artist:'R2-D2'},
      {n:'A-BDW', name:'Billy Dee Williams', artist:'Lando Calrissian'},
      {n:'A-CR', name:'Clive Revill', artist:'Emperor Palpatine'},
      {n:'A-DR2', name:'Deep Roy', artist:'Droopy McCool'},
      {n:'A-HC', name:'Hayden Christensen', artist:'Anakin Skywalker'},
      {n:'A-IM', name:'Ian McDiarmid', artist:'Supreme Chancellor Palpatine'},
      {n:'A-RP', name:'Ray Park', artist:'Darth Maul'},
      {n:'A-MC', name:'Michaela Cottrell', artist:'Even Piell'},
      {n:'A-DL', name:'Daniel Logan', artist:'Boba Fett'},
      {n:'A-HQ', name:'Hugh Quarshie', artist:'Captain Panaka'},
      {n:'A-MO', name:'Mary Oyaya', artist:'Luminara Unduli'},
      {n:'A-MK', name:'Michael Kingma', artist:'Tarfful'},
      {n:'A-KCH', name:'Keisha Castle-Hughes', artist:'Queen Apailana'},
      {n:'A-JC2', name:'John Coppinger', artist:'Senator Yarua'},
      {n:'A-AA', name:'Amy Allen', artist:'Aayla Secura'},
      {n:'A-AS', name:'Andrew Secombe', artist:'Watto'},
      {n:'A-RN', name:'Rohan Nichol', artist:'Captain Raymus Antilles'},
      {n:'A-BL2', name:'Bai Ling', artist:'Senator Bana Breemu'},
      {n:'A-RB', name:'Ralph Brown', artist:"Ric Olié"},
      {n:'A-NK', name:'Nalini Krishan', artist:'Barriss Offee'},
      {n:'A-FJ', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'A-RA', name:'Riz Ahmed', artist:'Bodhi Rook'},
      {n:'A-DY', name:'Donnie Yen', artist:'Chirrut Îmwe'},
      {n:'A-FW', name:'Forest Whitaker', artist:'Saw Gerrera'},
      {n:'A-AT', name:'Alan Tudyk', artist:'K-2SO'},
      {n:'A-TC', name:'Tosin Cole', artist:'Lieutenant Bastian'},
      {n:'A-PW', name:'Paul Warren', artist:'Varmik'},
      {n:'A-DR', name:'Daisy Ridley', artist:'Rey'},
      {n:'A-JB', name:'John Boyega', artist:'Finn'},
      {n:'A-AD', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'A-GC', name:'Gwendoline Christie', artist:'Captain Phasma'},
      {n:'A-SMG', name:'Sarah Michelle Gellar', artist:'Seventh Sister'},
      {n:'A-TB', name:'Tom Baker', artist:'Bendu'},
      {n:'A-FPJ', name:'Freddie Prinze Jr.', artist:'Kanan Jarrus'},
      {n:'A-AE', name:'Ashley Eckstein', artist:'Ahsoka Tano'},
      {n:'A-SS', name:'Stephen Stanton', artist:'Ben Kenobi'},
      {n:'A-SB2', name:'Steven Blum', artist:'Zeb Orrelios'},
      {n:'A-JI', name:'Jason Isaacs', artist:'The Grand Inquisitor'},
      {n:'A-PAR', name:'Philip Anthony-Rodriguez', artist:'Fifth Brother'},
      {n:'A-EL', name:'Eric Lopez', artist:'Oleg'},
      {n:'A-JAT', name:'James Arnold Taylor', artist:'Plo Koon'},
      {n:'A-NF', name:'Nika Futterman', artist:'Asajj Ventress'},
      {n:'A-SW', name:'Sam Witwer', artist:'Darth Maul'},
      {n:'A-TK', name:'Tom Kenny', artist:'Nute Gunray'},
      {n:'A-GT', name:'George Takei', artist:'Lok Durd'},
      {n:'A-JC', name:'Jim Cummings', artist:'Hondo Ohnaka'},
      {n:'A-OD', name:"Olivia d'Abo", artist:'Luminara Unduli'},
      {n:'A-DT', name:'David Tennant', artist:'Professor Huyang'},
      {n:'A-RB2', name:'Rajia Baroudi', artist:'Queen Miraj Scintel'},
      {n:'A-LS', name:'Lloyd Sherr', artist:'Mortis Father'},
    ]
  },
  {
    id: 'auto-dual', parallels: [{id:'orange',name:'Orange',print_run:5,color:'#ff9100'},{id:'red',name:'Red',print_run:1,color:'#ff1744'}], type: 'auto', title: 'DUAL AUTOGRAPHS — 10 CARDS',
    cards: [
      {n:'DA-1', name:'Adam Driver / Andy Serkis', artist:'Kylo / Snoke'},
      {n:'DA-2', name:'Felicity Jones / Riz Ahmed', artist:'Jyn / Bodhi'},
      {n:'DA-3', name:'John Boyega / Adam Driver', artist:'Finn / Kylo'},
      {n:'DA-4', name:'Greg Grunberg / Kipsang Rotich', artist:'Snap / Nien Nunb'},
      {n:'DA-5', name:'George Takei / Ashley Eckstein', artist:'Lok Durd / Ahsoka'},
      {n:'DA-6', name:'John Boyega / Matthew Wood', artist:'Finn / Quiggold'},
      {n:'DA-7', name:'Oliver Walpole / Megan Udall', artist:'Seek / Melee'},
      {n:'DA-8', name:"David Barclay / Gerald Home", artist:'Jabba Puppeteer / Tessek'},
      {n:'DA-9', name:'Brian Vernel / Yayan Ruhian', artist:'Bala-Tik / Tasu Leech'},
      {n:"DA-10", name:"Nika Futterman / Olivia d'Abo", artist:'Asajj Ventress / Luminara'},
    ]
  },
  {
    id: 'auto-triple', parallels: [{id:'red',name:'Red',print_run:1,color:'#ff1744'}], type: 'auto', title: 'TRIPLE AUTOGRAPHS — 4 CARDS',
    cards: [
      {n:'TA-1', name:'Harrison Ford / Carrie Fisher / Anthony Daniels', artist:'Han / Leia / 3PO'},
      {n:'TA-2', name:'Hayden Christensen / Ian McDiarmid / Matthew Wood', artist:'Prequel Cast'},
      {n:'TA-3', name:'Donnie Yen / Nick Kellington / Paul Kasey', artist:'Rogue One Cast'},
      {n:'TA-4', name:'Ashley Eckstein / Meredith Salenger / Nika Futterman', artist:'Clone Wars Cast'},
    ]
  },
  {
    // Six-Person Auto is numbered /2; this serialized slot lets collectors register 1/2–2/2.
    id: 'auto-six', parallels: [{id:'numbered',name:'',print_run:2,color:'#c8d8f0'}], type: 'auto', title: 'SIX PERSON AUTOGRAPH — 1 CARD',
    cards: [
      {n:'6A-1', name:'Daisy Ridley / John Boyega / Laura Dern / Andy Serkis / Adam Driver / Gwendoline Christie', artist:'Sequel Cast'},
    ]
  },
  {
    // Archive Signature buyback is 1/1 — no parallel ladder.
    id: 'auto-filoni', parallels: [], type: 'auto', title: 'ARCHIVE SIGNATURE — 1 CARD',
    cards: [
      {n:'AS-DF', name:'Dave Filoni', artist:'Chopper (Archive Signature, unslabbed)'},
    ]
  },
  {
    id: 'sketch', parallels: [], type: 'sketch', title: 'SKETCH CARD ARTISTS — 140+ ARTISTS',
    cards: [
      'Jeff Abar','Ben AbuSaada','Marlo Agunos','Nick Allsopp','Thomas Amici',
      'Matt Applegate','Colin Arthurs','Laura Atkinson','Angel Aviles','Kelly Baber',
      'Nicholas Baltra','Adam Beck','Angelina Benedetti','Jerry Bennett','Tina Berardi',
      'Dan Bergren','Brandon Blevins','Andy Bohn','John Bruce','Carlos Cabaleiro',
      'Neil Camera','Patricio Carrasco','Başak Çetinkaya','Oscar Chavez','Kevin Cleveland',
      'Kevin Cogan','Joe Corroney','Jamie Cosley','Carolyn Craggs','Kaela Croft',
      'Ryan Crosby','Ronnie Crowther','Dan Curto','Patrick Davis','Gorkem Demir',
      'Pablo Diaz','Vincenzo D\'Ippolito','Garrett Dix','Tim Dowler','Louise Draper',
      'Dean Drummond','Marcia Dye','Madison Emerick','Keith Farnum','Brett Farr',
      'Andrew Fernandes','Anthony Figaro','Rees Finlay','Ryan Finley','Andrew Fry',
      'Gerard Garcia Jr.','Dave Gaskin','Mick and Matt Glebe','Sammy Gomez','Fredd Gorham',
      'Dan Gorman','Kevin Graham','Tiffany Groves','Ingrid Hardy','Scott Harrell',
      'Phil Hassewer','Robert Hendrickson','Rich Hennemann','Jessica Hickman','Matthew Hirons',
      'Brad Hudson','Lee Hunt','Eli Hyder','Alex Iniguez','Sheikh Islam',
      'Mike James','Mohammad Jilani','George Joseph','Andrew Joynes','Nick Justus',
      'Frank Kadar','Caleb King','Travis Kinnison','Matt Langford','Eric Lehtonen',
      'Kevin Liell','Lee Lightfoot','Matthew Lopez','Craig Ludwick','Matt Maldonado',
      'Jay Manchand','Mark Mangum','Laura Martin','Michael Mastermaker','Jon McKenzie',
      'Chris Meeks','Jim Mehsling','Jason Miller','Alex Mines','Solly Mohamed',
      'Rich Molinelli','Logan Monette','Ryan Olsen','Jim O\'Riley','Marsha Parkins',
      'Kris Penix','Darrin Pepe','John Pleak','Bill Pulkovski','Brendan Purchase',
      'Jason Queen','David Rabbitte','Maggie Ransom','Michelle Rayner','Barry Renshaw',
      'Jamie Richards','Stephanie Rosales','Juan Rosales','Omar Salinas','Andrew Sanchez',
      'Adam Schickling','Brent Scotchmer','Richard Sensale','Richard Serrao','Anil Sharma',
      'Rebecca Sharp','Tim Shinn','Ward Silverman','Shaow Siong','Anthony Skubis',
      'Tim Smith','James Henry Smith','Tod Smith','Todd Aaron Smith','Veronica Smith',
      'Doug Snodgrass','Jason Sobol','Matt Stewart','Stephanie Swanger','Dan Tearle',
      'Rob Teranishi','Phillip Trujillo','Huy Truong','Brad Utterstrom','Kevin P. West',
      'Jeff West','Trent Westbrook','Zach Woolsey',
    ].map((a, i) => ({n:`SK-${i+1}`, name: a, artist:'Sketch Card Artist'}))
  },
];
export const PARALLELS = [
  { id: 'blue', name: 'Blue', print_run: null, color: '#2979ff' },
  { id: 'green', name: 'Green', print_run: null, color: '#00e676' },
  { id: 'purple', name: 'Purple', print_run: 99, color: '#b060ff' },
  { id: 'orange', name: 'Orange', print_run: 25, color: '#ff9100' },
  { id: 'plate-black', name: 'Printing Plate Black', print_run: 1, color: '#808080' },
  { id: 'plate-cyan', name: 'Printing Plate Cyan', print_run: 1, color: '#00e5ff' },
  { id: 'plate-magenta', name: 'Printing Plate Magenta', print_run: 1, color: '#e91e63' },
  { id: 'plate-yellow', name: 'Printing Plate Yellow', print_run: 1, color: '#ffee58' },
  { id: 'red', name: 'Red', print_run: 1, color: '#ff1744' },
];
export const AUTO_PARALLELS = [
  { id: 'blue', name: 'Blue', print_run: 50, color: '#2979ff' },
  { id: 'green', name: 'Green', print_run: 25, color: '#00e676' },
  { id: 'purple', name: 'Purple', print_run: 10, color: '#b060ff' },
  { id: 'orange', name: 'Orange', print_run: 5, color: '#ff9100' },
  { id: 'plate-black', name: 'Printing Plate Black', print_run: 1, color: '#808080' },
  { id: 'plate-cyan', name: 'Printing Plate Cyan', print_run: 1, color: '#00e5ff' },
  { id: 'plate-magenta', name: 'Printing Plate Magenta', print_run: 1, color: '#e91e63' },
  { id: 'plate-yellow', name: 'Printing Plate Yellow', print_run: 1, color: '#ffee58' },
  { id: 'red', name: 'Red', print_run: 1, color: '#ff1744' },
];
export const INSERT_PARALLELS = [
  { id: 'purple', name: 'Purple', print_run: 99, color: '#b060ff' },
  { id: 'orange', name: 'Orange', print_run: 25, color: '#ff9100' },
  { id: 'plate-black', name: 'Printing Plate Black', print_run: 1, color: '#808080' },
  { id: 'plate-cyan', name: 'Printing Plate Cyan', print_run: 1, color: '#00e5ff' },
  { id: 'plate-magenta', name: 'Printing Plate Magenta', print_run: 1, color: '#e91e63' },
  { id: 'plate-yellow', name: 'Printing Plate Yellow', print_run: 1, color: '#ffee58' },
  { id: 'red', name: 'Red', print_run: 1, color: '#ff1744' },
];
